import { Navigate } from "react-router-dom";
import { useAuth } from "../context/authContext";
//import { Navbar, Main, Product, Footer } from "../components";

export function ProtectedRoute({ children, ...rest }) {
  const { user, loading } = useAuth();


  if (loading) return <h1>Cargando</h1>;

  if (!user) {
    //alert("Debes iniciar sesion");
    return (
      <Navigate to="/login" />
    );
  }
  return <>{children}</>;
}


/*
      <div className="alert alert-warning text-center" role="alert">
          <h1 >Debes iniciar sesión</h1>
        </div>
  
*/ 